<template>
    <div class="card mb-4">
        <div class="card-header">
            <div class="pull-right mt-1">
                <strong>{{ $t('breakdown.pricingCurrency') }}:</strong> &nbsp;
                <img :src="window.getCurrencyFlag(carPackage.currency)" :alt="carPackage.currency">
                {{ carPackage.currency.toUpperCase() }}
            </div>
            <h2 class="card-title">{{ $t('breakdown.panelTitle') }}</h2>
        </div>
        <div v-if="!calculator.totals" class="alert alert-info alert-flush text-center">
            <i class="fa fa-fw fa-spinner fa-pulse fa-2x"></i>
        </div>
        <template v-else>
            <!--<div class="alert alert-secondary alert-flush" v-html="$t('breakdown.ctCommissionNotice')"></div>-->
            <div class="card-body">
                <price-breakdown-header :car-package="carPackage"
                                        :calculator="calculator"
                                        :errors="errors"
                                        @agency-markup-changed="handleAgencyMarkupChanged"
                                        @total-markup-changed="handleTotalMarkupChanged">
                </price-breakdown-header>
                <div class="row">
                    <price-breakdown-charges :car-package="carPackage" :calculator="calculator">
                    </price-breakdown-charges>
                    <price-breakdown-payouts :car-package="carPackage" :calculator="calculator">
                    </price-breakdown-payouts>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import Header from './PriceBreakdownHeader';
    import Charges from './PriceBreakdownCharges';
    import Payouts from './PriceBreakdownPayouts';

    export default {
        name: 'PriceBreakdown',
        props: ['carPackage', 'calculator', 'errors'],
        data() {
            return {};
        },
        methods: {
            handleAgencyMarkupChanged(markup) {
                this.$emit('agency-markup-changed', markup); //bubble
            },
            handleTotalMarkupChanged(markup) {
                this.$emit('total-markup-changed', markup); //bubble
            }
        },
        components: {
            priceBreakdownHeader: Header,
            priceBreakdownCharges: Charges,
            priceBreakdownPayouts: Payouts
        }
    };
</script>

<style scoped>

</style>